import { Button } from 'app/components/BasicButtons/Button';
import { useLayoutSlice } from 'app/Layout/FrontendLayout/slice';
import { RenderPageType } from 'app/Layout/FrontendLayout/slice/type';
import { RegionDetailsProps } from 'app/pages/Regions/RegionsDetailsPage/Details';
import { selectAuthenticatedUser } from 'app/slice/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { CellProps, Renderer } from 'react-table';
import { AuthenticatedUser } from 'types/AuthenticatedUser';

const RegionRenderer: Renderer<CellProps<Record<string, any>>> = ({
  value,
  row,
}) => {
  const dispatch = useDispatch();
  const { actions } = useLayoutSlice();
  const User: AuthenticatedUser | undefined = useSelector(
    selectAuthenticatedUser,
  );
  return !!User && User.isAdmin() ? (
    <Button
      variant="text"
      size="small"
      onClick={() =>
        dispatch(
          actions.openSidePanel({
            type: RenderPageType.RegionDetails,
            props: {
              useSidePanel: true,
              id: '' + row.original.Id,
              initialModel: row.original,
            } as RegionDetailsProps,
          }),
        )
      }
    >
      {value}
    </Button>
  ) : (
    <>{value}</>
  );
};
export default RegionRenderer;
